export module Exporting {

    interface Column {
        key: string;
        name: string;
        formatting?: (value: string) => string;
    }

    export function exportHTMLRaw(title: string, subtitle: string, rawHTML: string) {
        var printWindow = window.open();
        printWindow.document.write(buildHTML(title, subtitle, rawHTML));
        printWindow.document.close();
    }

    export function exportHTML(columns: Column[], rows: {}[], title: string, subtitle: string) {
        let innerContent;
        innerContent = `    <table border=1 style="border-spacing: 0; border-collapse: collapse; margin-bottom: 20px;">
                                <tr>`;
        columns.forEach(column => {
            innerContent += `       <td>${column.name}</td>`;
        });
        innerContent += `       </tr>`;
        rows.forEach(row => {
            innerContent += `   <tr>`;
            columns.forEach(column => {
                let value = getNestedValue(column.key, row);
                value = column.formatting ? column.formatting(value) : value;
                innerContent += `   <td>${value ? value : ''}</td>`;
            });
            innerContent += `   </tr>`;
        });
        innerContent += `   </table>`;
    
        var printWindow = window.open();
        printWindow.document.write(buildHTML(title, subtitle, innerContent));
        printWindow.document.close();
    }

    export function exportCSV(columns: Column[], data: {}[],  filename?: string) {
        let rows = [ columns.map(e => `"${e.name}"`).join(',') ];
        data.forEach(r => {
            let values = [];
            columns.forEach(column => {
                let value = getNestedValue(column.key, r);
                value = column.formatting ? column.formatting(value) : value;
                values.push(`"${value}"`);
            });
            rows.push(values.join(','));
        });

        this.downloadCSV(rows, filename);
    }

    export function generateCSV(columns: Column[], data: {}[]) {
        let rows = [ columns.map(e => `"${e.name}"`).join(',') ];

        data.forEach(r => {
            let values = [];
            columns.forEach(column => {
                let value = getNestedValue(column.key, r);
                value = column.formatting ? column.formatting(value) : value;
                values.push(`"${value}"`);
            });
            rows.push(values.join(','));
        });

        return rows;
    }

    export function downloadCSV(rows: string[], filename?: string) {
        let csvContent = "data:text/csv;charset=utf-8," + rows.join("\n");
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");

        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `${filename}.csv`);
        document.body.appendChild(link);

        link.click();
        link.remove();
    }

    function buildHTML(title: string, subtitle: string, innerContent: string): string {
        let html;

        html = `<html>
                    <head>
                        <style>
                            * { font-family: Arial, Helvetica, sans-serif; }
                            table { border: 1px solid; border-spacing: 0; border-collapse: collapse; margin-bottom: 20px; }
                            td { border: 1px solid; padding: 0 10px; }
                            .bold { font-weight: bold; }
                            .center { text-align: center; }
                            .right { text-align: right; }
                        </style>
                        <title>${title}</title>
                    </head>
                    <body>
                        <table style="border: 0;">
                            <tr><td style="border: 0;"><h2>${title}</h2></td></tr>
                            <tr><td style="border: 0;"><h3>${subtitle}</h3></td></tr>
                        </table>
                        ${innerContent}
                    </body>
                </html>`;

        return html;
    }

    function getNestedValue(key, obj): string {
        let hasNested: boolean = false;
        let temp = obj;
        key.split('.').forEach(k => {
            temp = temp[k] || 0;
            hasNested = true;
        });

        return !hasNested ? obj[key] : temp;
    }
}


// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/static/exporting.ts